// src/hooks/useTrips.js
import { useEffect, useState } from "react";
import {
  subscribeAllTrips, subscribeClientTrips,
  subscribePendingTrips, subscribeCaptainTrips,
} from "../services/tripService";

function useSubscription(fn, ...args) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const key = args.join("|");

  useEffect(() => {
    setLoading(true);
    setError(null);
    const unsub = fn(...args,
      d  => { setData(d); setLoading(false); },
      e  => { console.error(e); setError(e.message); setLoading(false); }
    );
    return () => unsub && unsub();
  }, [key]);

  return { data, loading, error };
}

export const useAllTrips     = ()         => useSubscription(subscribeAllTrips);
export const useClientTrips  = clientId  => useSubscription(subscribeClientTrips,  clientId);
export const usePendingTrips = ()         => useSubscription(subscribePendingTrips);
export const useCaptainTrips = captainId => useSubscription(subscribeCaptainTrips, captainId);
